import { Box, BoxProps, Flex } from '@chakra-ui/react';
import { CSSProperties } from 'react';
import { IconType } from 'react-icons';
import { DataDirection } from '../../../../core/types/ui/position';
import { ScrollButtonInteraction } from '../../../hooks/useScrollbar';
import { IStartDrag } from '../../../../core/hooks/useDraggable';
import { GridEntity } from '../../../types';

interface BackgroundProps {
  boxProps: BoxProps;
  stroke: string;
  children: React.ReactNode;
}
const Background: React.FC<BackgroundProps> = ({
  boxProps,
  stroke,
  children,
}) => (
  <Box
    background={'InfoBackground'}
    position="absolute"
    // display="inline-block"
    borderColor={stroke}
    borderStyle="solid"
    userSelect="none"
    as={Flex}
    zIndex={10}
    overflow="hidden"
    {...boxProps}
    onContextMenu={(e) => {
      e.preventDefault();
      e.stopPropagation();
    }}
  >
    {children}
  </Box>
);

interface SectionProps {
  sectionProps: BoxProps;
  children: React.ReactNode;
}
const Section: React.FC<SectionProps> = ({ sectionProps, children }) => (
  <Box
    position="relative"
    as={Flex}
    justifyContent="flex-end"
    {...sectionProps}
  >
    {children}
  </Box>
);

interface ActionButtonGroupProps {
  stroke: string;
  buttonGroupProps: BoxProps;
  children: React.ReactNode;
}
const ActionButtonGroup: React.FC<ActionButtonGroupProps> = ({
  stroke,
  buttonGroupProps,
  children,
}) => (
  <Box
    borderColor={stroke}
    borderStyle="solid"
    as={Flex}
    overflow="hidden"
    alignItems={'center'}
    justifyContent="center"
    {...buttonGroupProps}
  >
    {children}
  </Box>
);

interface ActionButtonProps {
  background: string;
  Icon: IconType;
  buttonProps: BoxProps;
  direction: DataDirection;
  onMouseDown?: ScrollButtonInteraction;
  onClick?: ScrollButtonInteraction;
  entityType: GridEntity;
}
const ActionButton: React.FC<ActionButtonProps> = ({
  background,
  Icon,
  buttonProps,
  direction,
  onMouseDown,
  onClick,
  entityType,
}) => {
  // console.log("onClick", onClick, " dire", direction, entityType)
  return (
    <Box
      as={Flex}
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      opacity={0.6}
      _hover={{
        opacity: 1,
        background: background,
        transform: 'scale(1.1)',
      }}
      transition="all .3s ease-in"
      {...buttonProps}
      onMouseDown={() => onMouseDown && onMouseDown(entityType, direction)}
      onClick={() => onClick && onClick(entityType, direction)}
      // onClick={() => console.log("click")}
    >
      <Icon />
    </Box>
  );
};

interface ThumbProps {
  background: string;
  styleProps: BoxProps;
  // hoverStyle: CSSProperties;
  thumbRef?: React.ForwardedRef<HTMLDivElement>;
  onThumbMouseDown?: IStartDrag;
}

const ScrollThumb: React.FC<ThumbProps> = ({
  background,
  styleProps,
  // hoverStyle,
  thumbRef,
  onThumbMouseDown,
}) => {
  return (
    <Box
      position="relative"
      transition=".2s opacity ease-in"
      _hover={{
        opacity: 1,
      }}
      background={background}
      borderRadius="4px"
      opacity={0.7}
      {...styleProps}
      onMouseDown={onThumbMouseDown}
      ref={thumbRef}
    />
  );
};
export { Background, Section, ActionButtonGroup, ActionButton, ScrollThumb };
